import axios from 'axios'
import { useQuery } from 'react-query'
import { GenericQueryOptions, longStaleTime } from '.'
import { GetMakersRequest, VehicleIdentificationDto } from '../dtos/Step1'
import { VinOnlineVehicleDto, VehiclesIdentificationDto, VehicleValuationDto } from '../dtos/VinOnline'

const baseUrl = process.env.PUBLIC_URL
const apiUrl = process.env.REACT_APP_VINONLINE_API
const url = `${baseUrl}/${apiUrl}`

const fetchFindVehicle = (paramsId?: string, spz?: string, vin?: string, techCertNumber?: string) =>
    axios.get<VinOnlineVehicleDto>(`${url}/FindVehicle?paramsId=${paramsId ?? ''}&licensePlate=${spz ?? ''}&vin=${vin ?? ''}&techCertNumber=${techCertNumber ?? ''}`)

const fetchVehicleIdentification = (paramsId?: string, spz?: string, vin?: string) =>
    axios.post<VehiclesIdentificationDto>(`${url}/vehicleIdentification?paramsId=${paramsId ?? ''}&licensePlate=${spz ?? ''}&vin=${vin ?? ''}`)

export type VehicleValuationModel = {
    paramsId?: string
    licensePlate: string
    vin: string
    vehicleId: string
    firstRegistrationDate: Date
    accSelected?: string
    mileage?: number | null
}

const fetchVehicleValuation = (data: VehicleValuationModel) =>
    axios.post<VehicleValuationDto>(`${url}/VehicleValuation`, data)

export const useFindVehicle = (
    paramsId?: string,
    spz?: string,
    vin?: string,
    techCertNumber?: string,
    options?: GenericQueryOptions<VinOnlineVehicleDto>) => {
    return useQuery(["vinOnline-findVehicle", paramsId, spz, vin, techCertNumber],
        () => fetchFindVehicle(paramsId, spz, vin, techCertNumber),
        { staleTime: longStaleTime, ...options })
}

export const useVehicleIdentification = (
    paramsId?: string,
    spz?: string,
    vin?: string,
    options?: GenericQueryOptions<VehicleIdentificationDto>) => {
    return useQuery(["vinOnline-vehicleIdentification", paramsId, spz, vin],
        () => fetchVehicleIdentification(paramsId, spz, vin),
        { staleTime: longStaleTime, ...options })
}

export const useVehicleValuation = (data: VehicleValuationModel,
    options?: GenericQueryOptions<VehicleValuationDto>) => {
    return useQuery(["vinOnline-vehicleValuation", data.vehicleId],
        () => fetchVehicleValuation(data),
        { staleTime: longStaleTime, ...options })
}